import { computed, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { AuthStatus } from '../models';
import { UserNotificationService } from './user.notification.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private tokenExpirationSubject = new BehaviorSubject<boolean>(false); // Emite cuando el token expira
  private _authStatus = signal<AuthStatus>(AuthStatus.checking); // Verificar el estado de la autenticación

  // Señal computada, no puede ser modificada
  public authStatus =  computed(() => this._authStatus());

  constructor(private router: Router, private userNotificationService:UserNotificationService) {}

  // Observable para subscribirse y saber cuando el token expira
  get tokenExpiration$(): Observable<boolean> {
    return this.tokenExpirationSubject.asObservable();
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  getTokenExpiration(): number | null {
    const expiration = localStorage.getItem('tokenExpiration');
    return expiration ? Number(expiration) : null;
  }

  saveToken(token: string, expirationTime: number): void {
    if (!token || !expirationTime || isNaN(expirationTime) || expirationTime <= Date.now()) {
      return;
    }

    localStorage.setItem('token', token);
    localStorage.setItem('tokenExpiration', expirationTime.toString());
    sessionStorage.setItem('sessionActive', 'true');

    this._authStatus.set(AuthStatus.authenticated);

    const timeLeft = expirationTime - Date.now();
    this.tokenExpirationMonitor(timeLeft);
  }

  checkTokenOnAppStart(): void {
    const expirationTime = this.getTokenExpiration();

    if (!expirationTime) {
      this._authStatus.set(AuthStatus.notAuthenticated);
      return;
    }

    const currentTime = Date.now(); // Obtiene el tiempo actual en milisegundos
    const timeLeft = expirationTime - currentTime; // Calcula el tiempo restante para la expiración del token

    if (timeLeft > 0) {
      this._authStatus.set(AuthStatus.authenticated);
      this.tokenExpirationMonitor(timeLeft); // Inicia monitoreo
    } else {
      this.logout(true);
    }
  }

  logout(isExpired:boolean): void {
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiration');
    sessionStorage.clear();
    this._authStatus.set(AuthStatus.notAuthenticated); // Actualiza estado de autenticación

    if (isExpired) {
      this.userNotificationService.showWarning('ALERTS.SESSION-EXPIRED');
    }

    this.router.navigate(['/sign-in'], { replaceUrl: true });
    this.tokenExpirationSubject.next(true); // Emite que el token ha expirado
  }

  private tokenExpirationMonitor(expiresIn: number): void {
   timer(expiresIn).subscribe(() => {
    this.logout(true);
  });
}
}
